<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { mapState } from "pinia";
import { useConfigurationStore } from "%/dynamic-component-editor/stores/configuration-store";
import ActionCountElement
  from "%/dynamic-component-editor/standard-elements/action-element/ActionCountElement.vue";
import DisplayValue from "%/dynamic-component-editor/options/display-value";
import { countToShow, isCountShown } from "%/dynamic-component-editor/helpers/story-engagement.mjs";
import HideCountAtZero from "%/dynamic-component-editor/options/hide-count-at-zero";
import ButtonActionCountOptions from "%/dynamic-component-editor/bundles/button-action-count-options";
import { ENGAGEMENT_ICONS } from "%/dynamic-component-editor/standard-elements/action-element/engagement-action-mixin";

export default {
  name: "DownvoteScore",
  elementPanelSettings: {
    displayName: "Downvote Score",
    displayIcon: "material-symbols:filter-1-outline",
    elementType: "element",
    elementGroup: "storyElements",
  },
  extends: ActionCountElement,
  mixins: [StoryPageElementMixin],
  options: [
    new HideCountAtZero({ default: true }),
  ],
  optionBundles: [
    new ButtonActionCountOptions({ "default.icon": ENGAGEMENT_ICONS.downvote, "default.display-icon": "hide" }),
  ],
  computed: {
    ...mapState(useConfigurationStore, [
      "canVoteOnPosts",
    ]),
    shouldShowAction() {
      return isCountShown({
        editMode: this.editMode,
        featureOn: this.canVoteOnPosts,
        count: this.entity.downvoteScore,
        hideAtZero: this.getOptionValue(HideCountAtZero),
      });
    },
    myValue() {
      return countToShow(this.entity.downvoteScore, this.getOptionValue(DisplayValue));
    },
  },
  methods: {
    handleClick() {
      window.location.href = `${this.links.web}/story/${this.entity.storyId}`;
    },
  },
};
</script>
